import { MedicalNotePinOption } from "@/Common/Models/Employee/Enums/MedicalNotePinOption";

class NoteStreamlineSettings {
    public NewMedicalNotePinnedAction: MedicalNotePinOption;
    public SavedMedicalNotePinnedAction: MedicalNotePinOption;

    public constructor(init?: Partial<NoteStreamlineSettings>) {
        Object.assign(this, init);
    }

    public static fromModel(model: NoteStreamlineSettings): NoteStreamlineSettings {
        return new NoteStreamlineSettings(model);
    }
}

export { NoteStreamlineSettings };
